
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/progressbar",
      function () {
        return require("private-next-pages/components/progressbar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/progressbar"])
      });
    }
  